import { Button } from "@/components/ui/primitives";
import { AlertTriangle } from "lucide-react";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center px-4 text-center">
      <span className="animate-pop-in mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-danger-soft">
        <AlertTriangle className="h-8 w-8 text-danger" />
      </span>
      <h1 className="text-2xl font-extrabold tracking-tight text-text">
        Something went wrong
      </h1>
      <p className="mt-3 max-w-sm text-text-muted">
        An unexpected error occurred. You can try again, and if it keeps happening please
        come back later.
      </p>
      <div className="mt-8 flex gap-3">
        <Button variant="accent" onClick={reset}>
          Try again
        </Button>
        <Button variant="outline" onClick={() => window.location.assign("/")}>
          Go home
        </Button>
      </div>
    </div>
  );
}
